<template>
  <div
    :style="styles.base"
    :class="getCss('base')"
  >
    <canvas class="pag-anime-canvas" :id="`pag-anime-${this.uid}`"></canvas>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
const DEFAULT_PAG_FILE = 'https://act.xinyue.qq.com/assets/pag/like.pag';
export default {
  name: 'CPag',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'pag-anime-',
      pagInstance: null,
      pagView: null,
      pagCanvas: null,
      pagFile: null,
      pagWidth: 0,
      pagHeight: 0,
      pagHWRatio: 0,
      resizeCoolDown: null,
    };
  },
  watch: {
    'styles.base.width': {
      handler() {
        this.resizePagCanvas();
      },
      immediate: true,
    },
    'configurationData.pagFile.url': {
      handler() {
        this.createPAGView();
      },
      immediate: true,
    },
  },
  async mounted() {
    const that = this;
    if (this.$isInEditor) {
      that.pagInstance = window.PAG;
      await that.createPAGView();
    }
    // 实例化 PAG
    this.$nextTick(async () => {
      // await this.createPAGView();
      if (that.configurationData?.isInPop) {
        that.pagInstance = window.PAG;
        await that.createPAGView();
        return;
      }
      window.addEventListener(
        'PAGInitReady',
        (e) => {
          console.log('PAGInitReady', e);
          that.pagInstance = window.PAG;
          that.createPAGView();
        },
        {
          once: true,
        },
      );
    });
  },
  methods: {
    async createPAGView() {
      try {
        if (!this.pagInstance) {
          // 监听 在pag未init的时候执行报错
          return;
        }
        // 清除上一个 PAG 相关的资源
        if (this.pagFile) {
          this.pagFile.destroy();
        }
        if (this.pagView) {
          this.pagView.destroy();
        }
        // 获取 PAG 素材数据
        const buffer = await fetch(this.configurationData.pagFile?.url || DEFAULT_PAG_FILE)
          .then(response => response.arrayBuffer());
        // 加载 PAG 素材为 PAGFile 对象
        this.pagFile = await this.pagInstance.PAGFile.load(buffer);

        // 动效文件的高/宽比
        this.pagWidth = this.pagFile.width() ?? 0;
        this.pagHeight = this.pagFile.height() ?? 0;
        this.pagHWRatio = this.pagHeight / this.pagWidth;
        this.calcPagCanvasSize();
        // 实例化 PAGView 对象
        // 由于 VideoReader 模块在 Web 平台依赖于 VideoElement，所以在部分移动端场景下，pagView?.init 不是在用户交互产生的调用链中，可能会存在不允许播放导致无法正常渲染画面的问题。
        // 当出现这种情况，我们推荐取消首帧渲染
        this.pagView = await this.pagInstance.PAGView.init(this.pagFile, this.pagCanvas, {
          firstFrame: false,
          useScale: false,
        });
        // 设置动画循环播放次数：0 代表无限循环
        this.pagView.setRepeatCount(this.configurationData.repeatCount || 0);
        // 播放 PAGView
        await this.pagView.play();
      } catch (e) {
        console.log('error e', e);
      }
    },
    calcPagCanvasSize() {
      // 将画布尺寸设置为 PAGFile的尺寸
      this.pagCanvas = document.getElementById(`pag-anime-${this.uid}`);
      if (this.pagCanvas) {
        // 确认已经挂载到 DOM 完毕后再执行尺寸计算
        if (this.styles.base?.width?.endsWith('px')) {
          // pc 页面
          this.pagCanvas.width = parseFloat(this.styles.base?.width) * window.devicePixelRatio;
          this.pagCanvas.height = this.pagCanvas.width * this.pagHWRatio;
        } else if (this.styles.base?.width?.endsWith('rem')) {
          // 移动端页面
          const fontSizeNumber = parseFloat(getComputedStyle(document.documentElement).fontSize);
          const styleWidthNumber = parseFloat(this.styles.base?.width);
          // 将 rem 重新计算成 px 值
          this.pagCanvas.width = fontSizeNumber * styleWidthNumber * window.devicePixelRatio;
          this.pagCanvas.height = this.pagCanvas.width * this.pagHWRatio;
        } else {
          // 默认
          this.pagCanvas.width = this.pagWidth;
          this.pagCanvas.height = this.pagHeight;
        }
        // 让画布的 css 宽度与组件保持一致
        this.pagCanvas.style.width = this.styles.base?.width ?? this.pagCanvas.width;
      }

      // 监听 window 大小变化后重新计算画布尺寸
      window.onresize = () => {
        if (this.resizeCoolDown) {
          clearTimeout(this.resizeCoolDown);
          this.resizeCoolDown = null;
        }
        this.resizeCoolDown = setTimeout(() => {
          this.resizePagCanvas();
        }, 300);
      };
    },
    resizePagCanvas() {
      this.calcPagCanvasSize();
      if (this.pagView) {
        this.pagView.updateSize();
        this.pagView.flush();
      }
    },
  },
};
</script>
<style lang="scss">
  @import './pag.scss';
</style>
